module.exports = __webpack_public_path__ + "img/close.aad7d29e.svg";